import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CalendarX2 } from "lucide-react";
import { InviteCanvas } from "../components/InviteCanvas";
import { RsvpDialog } from "../components/RsvpDialog";
import { GuestList } from "../components/GuestList";
import { SiteFooter } from "../components/BrandLogo";
import { PasswordPrompt } from "../components/PasswordPrompt";
import { PageLoader } from "../context/AuthContext";
import { api, getInviteToken, imageUrl, inviteTokenKey } from "../lib/api";

export default function GuestPage() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [status, setStatus] = useState("loading");
  const [open, setOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [unlockKey, setUnlockKey] = useState(0);

  useEffect(() => {
    api
      .get(`/public/events/${slug}`)
      .then(({ data }) => {
        setEvent(data);
        setStatus("ready");
        document.title = `${data.occasion} · Invite PeopleiKnow`;
      })
      .catch((err) => {
        if (err.response?.status !== 401) return setStatus("missing");
        localStorage.removeItem(inviteTokenKey(slug));
        setStatus("locked");
      });
  }, [slug, unlockKey]);

  return (
    <main className="confetti-bg-white font-manrope min-h-screen text-slate-900">
      {status === "loading" && <PageLoader />}
      {status === "missing" && (
        <div data-testid="guest-not-found" className="mx-auto max-w-md px-6 py-24 text-center">
          <CalendarX2 className="mx-auto h-12 w-12 text-blue-500" />
          <h1 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-slate-900">Invite not found</h1>
          <p className="mt-2 text-slate-500">This link may have expired or been removed by the host.</p>
        </div>
      )}
      {status === "locked" && (
        <div className="mx-auto w-full max-w-lg px-3 py-6 sm:px-4 sm:py-12">
          <PasswordPrompt slug={slug} onUnlocked={() => setUnlockKey((k) => k + 1)} />
          <SiteFooter />
        </div>
      )}
      {status === "ready" && (
        <div className="mx-auto w-full max-w-lg px-3 py-6 sm:px-4 sm:py-12">
          <p data-testid="guest-invited-label" className="mb-6 text-center text-2xl font-bold uppercase leading-none tracking-[0.25em] text-blue-700">You're invited</p>
          <div className="rise">
            <InviteCanvas event={event} imageSrc={imageUrl(event.image_path, getInviteToken(slug))} onRsvp={() => setOpen(true)} />
          </div>
          <GuestList slug={event.slug} refreshKey={refreshKey} />
          <SiteFooter />
          <RsvpDialog open={open} onOpenChange={setOpen} event={event} onSubmitted={() => setRefreshKey((k) => k + 1)} />
        </div>
      )}
    </main>
  );
}
